module.exports = __webpack_public_path__ + "img/error.677a8ce9.png";